var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-notifications"},[_c('div',{staticClass:"header-notifications-trigger"},[_c('NuxtLink',{attrs:{"to":_vm.to || _vm.currentRoute,"rel":"nofollow"}},[_vm._t("trigger",function(){return [_c('IconBell'),_vm._v(" "),_c('span',[_vm._v("4")])]})],2)],1),_vm._v(" "),_vm._t("dropdown")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }